<template>
  <button class="button-work" @click="onClick">
    <img
      src="@/assets/talento_agv/img/home/img-button-work.png"
      alt="Button-Work"
      class="button-img"
    />
  </button>
</template>

<script setup>
import { router } from "@/router";

const props = defineProps({
  palabra_clave: {
    type: String,
    default: "",
  },
});

const onClick = () => {
  router.push(
    "/dashboard_ofertas_laborales?keyword=" + encodeURIComponent(props.palabra_clave)
  );
};
</script>

<style scoped>
.button-work {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.button-img {
  width: 85px;
  height: auto;
  object-fit: contain;
  transition: transform 0.2s ease-in-out;
}

.button-img:hover {
  transform: scale(1.1);
}
</style>
